import axios from 'axios';
import { API_HOST} from '@/utils/env';
import { Dialog } from 'vant';
import router from '@/router';

const config = {
    timeout: 120 * 1000,
    baseURL: API_HOST,
    retry: 3, // 重试次数
    retryDelay: 3000, // 重试延时
    shouldRetry: (error: any) => {
        if (error && error.response) {
            return false;
        } else {
            return true;
        }
    }, // 重试条件，默认只要是错误都需要重试
    transformResponse: [(data: any) => {
        const res: any = JSON.parse(data);
        // console.log(res);
        // if (res.code === 202) {
        //     Dialog.alert({
        //         title: '提示',
        //         message: '登录失效，请重新登录'
        //       }).then(() => {
        //         localStorage.removeItem('token');
        //         localStorage.removeItem('phone');
        //         router.push({ path: '/login'});
        //       });
        // }
        return res;
    }]
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
    config => {
        if (localStorage.getItem('token')) {
            config.headers.token = localStorage.getItem('token');
        }
        return config;
    },
    error => {
        // Do something with request error
        return Promise.reject(error);
    }
);

export default _axios;
